// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL: 'https://devapi.appskillsontario.com/api/', // development
  // API_URL: 'http://localhost:3100/api/', // development


  // API_URL: 'https://api.appskillsontario.com/api/', // production
  // 'http://ec2-3-99-57-179.ca-central-1.compute.amazonaws.com:3100/api/',
  // API_URL: 'https://devapi.appskillsontario.com/api/' // testing
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
